import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPieChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pie-chart-1, graph, chart, statistics"} maskId="square-filled-radius-0-stroke-1-IconPieChart1"><path d="M11.5 2.01227V12.3536L21.2525 15.8005C19.7565 19.4385 16.1774 22 12 22C6.47715 22 2 17.5228 2 12C2 6.6448 6.20944 2.27278 11.5 2.01227Z" fill="currentColor"/><path d="M12.5 2.01227V11.6464L21.5857 14.8577C21.8553 13.9522 22 12.993 22 12C22 6.6448 17.7906 2.27278 12.5 2.01227Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPieChart1;
